import { Component, OnInit, inject, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { MatChipsModule } from '@angular/material/chips';
import { MatButtonModule } from '@angular/material/button';
import { CareerPageService } from '../../../services/career-page.service';
import { MatIcon } from '@angular/material/icon';
import { UserService } from '../../../services/user.service';
import { CounselorNav } from '../../views/counselor-view/counselor-nav/counselor-nav';
import { StudentNav } from '../student-nav/student-nav';
import { CareerType } from '../../../models/careerType';
import { toFileUrl } from '../../../helpers/file-url';

@Component({
  selector: 'app-counselor-career-page',
  standalone: true,
  imports: [
    CommonModule,
    RouterLink,
    MatChipsModule,
    MatButtonModule,
    MatIcon,
    CounselorNav,
    StudentNav,
  ],
  templateUrl: './counselor-career-page.html',
  styleUrl: './counselor-career-page.css',
})
export class CounselorCareerPage implements OnInit {
  careerService = inject(CareerPageService);
  route = inject(ActivatedRoute);
  cdr = inject(ChangeDetectorRef);
  userService = inject(UserService);
  career: any;
  user: any;

  careerTypes: CareerType[] = [];

  constructor() {}

  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      const id = params.get('id');

      if (id) {
        this.getCareer(id);
      }
    });
    this.getCareerTypes();
  }

  getCareer(id: string) {
    this.careerService.getCareerById(id).subscribe({
      next: (career) => {
        this.career = career;
        this.cdr.detectChanges();
      },
    });
  }

  getCareerTypes() {
    this.careerService.getTypes().subscribe({
      next: (types) => {
        this.careerTypes = types;
        this.cdr.detectChanges();
      },
    });
  }
  galleryUrl(path: string): string {
    return toFileUrl(path) ?? '';
  }

  get bannerUrl(): string {
    return (
      toFileUrl(this.career.banner.path) ??
      'https://images.unsplash.com/photo-1498050108023-c5249f4df085?w=1200&q=80'
    );
  }

  get bannerPositionY(): string {
    return (this.career.banner?.positionY ?? 50) + '%';
  }
}
